// ИИ-ядро (deus_ii_yadro, legendary):
//   passive: Не может атаковать.                      — обработано в фильтре atk<=0 + Card.cantAttack.
//   trigger 2-я линия (начало хода):                  +2 Влияния владельцу (изменено в А.4.4.2-fix1).
//   trigger 1-я линия (конец хода):                    +0/2/0 случайному союзному Юниту (хил брони, ≤ max).

import { addInfluence } from './influence.js';

export const CARD_ID = 'deus_ii_yadro';

// В начале хода (после тяги) — на 2-й линии: +2 Влияния.
export function iiYadroOnTurnStart(state, ownerIdx, card) {
  if (!card || !card.isAlive() || card.line !== 1) return;
  addInfluence(state, ownerIdx, 2, 'ИИ-ядро [2-я линия]');
}

// В конце хода — на 1-й линии: +2 брони случайному союзнику (cap на max, восстанавливает).
export function iiYadroOnEndOfTurn(state, ownerIdx, card) {
  if (!card || !card.isAlive() || card.line !== 0) return;
  const p = state.players[ownerIdx];
  const allies = p.unitsOnField().filter(u => u !== card);
  if (allies.length === 0) return;
  const ally = allies[state.rng.int(allies.length)];
  const cap = ally.maxArmorWithMods;
  const before = ally.armor;
  const newArmor = Math.min(cap, before + 2);
  const gained = newArmor - before;
  if (gained > 0) {
    ally.current.armor = newArmor;
    state.log.add(`🤖 ИИ-ядро [${p.name}]: восстановил ${ally.name_ru} +0/${gained}/0 (броня=${ally.armor})`);
  }
}
